import { Box, Button, Card, CardContent, Typography } from "@mui/material"
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import IconButton from '@mui/material/IconButton';

const SuministrosUsuario = ({suministros}) => {

  const navigate = useNavigate();


    return(
        <>          
        <Box p={2} maxWidth={900} mx="auto" display="flex" alignItems="center">
            <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: 'bold' }}
            >
            Suministros{' '}
            <Box component="span" sx={{ color: '#64AE37', fontWeight: 'bold' }}>
                asociados.
            </Box>
            </Typography>
            <Box sx={{ ml: 'auto' }}>
                <Button
                variant="contained"
                sx={{
                    bgcolor: 'white',
                    color: '#64AE37',
                    boxShadow: 2,
                    borderRadius: 2,
                    textTransform: 'none',
                    '&:hover': { bgcolor: 'grey.100' },
                }}
                onClick={() => navigate("/agregarsuministro")}
                >
                Agregar suministro
                </Button>
            </Box>
            </Box>   
              {suministros.length === 0 && (
                <Typography>No tenés suministros asociados.</Typography>
              )}
        
            {suministros.map((s) => (
            <Card
            onClick={() =>
                    navigate(`/suministro/${s.Id}`, { state: { suministro: s } })
                   }
                key={s.id}
                sx={{
                mb: 2,
                borderRadius: 3,
                boxShadow: 4,
                borderLeft: '4px solid #64AE37',
                '&:hover': { boxShadow: 6, transform: 'translateY(-2px)', transition: '0.3s' },
                }}
            >
                        <CardContent
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                        }}
                        >

                <Box >
                    <Box display="flex" alignItems="center" mb={1}>
                    <AccountCircleIcon sx={{ mr: 1 }} />
                    <Typography variant="subtitle1" color="text.secondary">
                        <strong>{s.CliApe}</strong>
                    </Typography>
                    </Box>

                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    <strong>Nro socio:</strong> {s.CliCod} &nbsp; <strong>Suministro:</strong> {s.SumNro}
                    </Typography>
                    <Typography variant="subtitle2" color="text.secondary">
                    <strong>Dirección:</strong> {s.InmDom}
                    </Typography>
                </Box>

                <Box sx={{ mt: 0 }}>
                <IconButton
                    color="primary"
                    onClick={() =>
                    navigate(`/suministro/${s.Id}`, { state: { suministro: s } })
                    }
                >
                    <ArrowForwardIosIcon  sx={{ fontWeight: 'bold', fontSize:25}} />
                </IconButton>
                </Box>
                </CardContent>
            </Card>
            ))}
    </>
    )
}

export default SuministrosUsuario;